<template>
  <div class="mermber_limited">
    <!-- <Bar title="小盒会员超值特惠" v-if="token && source" /> -->
    <div class="main">
      <img :src="imgResource + 'limited-one-yuan-1.png?v=4'" alt="" class="bg" />
      <div class="center-img">
        <img :src="imgResource + 'limited-one-yuan-2.png?v=1'" alt="" />
        <span class="agreement one">
          <span class="one">*点击开通即为同意</span>
          <span class="two" @click="goAgreement1">《会员服务协议》</span>
          <span class="three" @click="goAgreement2">《自动续费协议》</span>
        </span>
        <span class="agreement two">
          <span class="one">*首月1元 次月30元</span>
        </span>
      </div>
    </div>
    <div class="footer">
      <div class="btn-img" @click="goPay">
        <img :src="imgResource + 'limited-one-yuan-3.png'" alt="" />
      </div>
      <div class="placeholder_btn"></div>
    </div>
  </div>
</template>
<script>
import ajax from "@/api/memberAjax.js";
// import Bar from "./member_bar";
import utils from "@/assets/js/utils";
export default {
  components: {
    // Bar
  },
  data() {
    return {
      imgResource: "https://susuanqiniu.knowbox.cn/fe/small-block/"
    };
  },
  created() {
    this.token = utils.getQueryString("token");
    this.version = utils.getQueryString("version");
    this.source = utils.getQueryString("source");
    this.getData();
    window.failToast = function (res) {
      if (res == "cancel") {
        this.$toast("支付失败");
      }
    };
    utils.sendLog(
      {
        token: this.token,
        version: this.version,
        source: this.source,
      },
      "hzxx3150"
    );
  },
  methods: {
    async getData() {
      const [resp] = await ajax.all([
        ajax.get("/pay/common/member-sale-page-new", {
          params: {
            token: this.token,
            version: this.version,
            source: this.source,
            onlyShowPromotion: 1
          }
        })
      ]);
      if (resp.data.code == 99999) {
        this.dataObj = resp.data.data;
      }
    },
    goAgreement1() {
      let url = window.location.href.split("?")[0];
      let path = url.split("member_limited_one").join("member_service_agreement");
      url = encodeURIComponent(path + "?hideTitleBar=false");
      window.location.href = "hybird://method/openNewWindow?url=" + url + "&title=小盒家长会员服务协议";
    },
    goAgreement2() {
      let url = window.location.href.split("?")[0];
      let path = url.split("member_limited_one").join("member_xufei");
      url = encodeURIComponent(path + "?hideTitleBar=false");
      window.location.href = "hybird://method/openNewWindow?url=" + url + "&title=自动续费协议";
    },
    goPay() {
      utils.sendLog(
      {
        token: this.token,
        version: this.version,
        source: this.source,
      },
      "hzxx3151"
    );
      let productItem = null;
      if (this.dataObj && Array.isArray(this.dataObj.memberProductList) && this.dataObj.memberProductList.length) {
        productItem = this.dataObj.memberProductList[0];
        let url =
          this.source === "iPhoneNewParent"
            ? `hybird://method/openDirectPay?productId=${productItem.productId}&jsCallBack=failToast`
            : `hybird://method/${productItem.isPureSign == 1 ? "openFreeDirectPay" : "openDirectPay"}?productId=${productItem.productId}&jsCallBack=failToast&productName=${productItem.title}&comeFrom=112&paymentChannel=wx`;
        setTimeout(() => {
          window.location.href = url;
        }, 100);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.mermber_limited {
  width: 100%;
  min-height: 100vh;
  background: #f54414;
  padding-top: env(safe-area-inset-top);
  padding-right: env(safe-area-inset-right);
  padding-bottom: env(safe-area-inset-bottom);
  padding-left: env(safe-area-inset-left);
  box-sizing: border-box;
  .main {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    padding-bottom: 1.74rem;
    .bg {
      width: 100%;
    }
    .center-img {
      margin-top: -4.5rem;
      width: 100%;
      position: relative;
      img {
        width: 100%;
      }
      .agreement {
        font-size: 0.22rem;
        font-family: Source Han Sans CN;
        display: flex;
        align-items: center;
        padding-top: 0.27rem;
        position: absolute;
        left: 0.61rem;
        &.one {
          bottom: 0.88rem;
        }
        &.two {
          bottom: 0.48rem;
        }
        .one {
          color: #6d2412;
        }
        .two {
          color: #fec812;
          padding: 0 0.22rem;
        }
        .three {
          color: #fec812;
        }
      }
    }
  }
  .footer {
    position: fixed;
    background-color: #ffffff;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 0.13rem;
    .btn-img {
      width: 100%;
      height: 1.03rem;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      img {
        width: 100%;
      }
    }
    .placeholder_btn {
      height: constant(safe-area-inset-bottom);
      height: env(safe-area-inset-bottom);
      background: #fff;
    }
  }
}
</style>
